import styled from "styled-components";

export const Separator = styled.div`
  padding: 0 12px;
  color: #5b5a6c;
`;

export const SeparatorX = styled.div`
  padding-left: 8px;
`;

export const Accordion = styled.div`
  display: flex;
  align-items: center;
  & svg {
    flex: none;
  }
`;

export const VerticalBarContainer = styled.div`
  padding: 0 11.5px;
`;

export const VerticalBar = styled.div`
  background-color: var(--slate);
  width: 1px;
  height: 24px;
`;
